export const CHAPTERS = [
  {
    num: "01",
    title: "Gifting",
    tagline: "Gifts that feel personal.",
    image:
      "https://images.unsplash.com/photo-1513201099705-a9746e1e201f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBnaWZ0JTIwcmliYm9ufGVufDB8fHx8MTc4NzM4NDU3MHww&ixlib=rb-4.1.0&q=85",
    imageAlt: "Gift box tied with a soft pink ribbon",
    services: [
      {
        slug: "personalised-gifts",
        name: "Personalised Gifts",
        desc: "Made with their name, story or memory.",
        items: [
          "Mugs, tumblers & bottles",
          "Frames, plaques & keepsakes",
          "Candles, cushions & blankets",
          "Baby, couple & teacher gifts",
          "Graduation & milestone gifts",
        ],
      },
      {
        slug: "curated-hampers",
        name: "Curated Hampers",
        desc: "Beautifully built around the occasion.",
        items: [
          "Build-your-own gift boxes",
          "Birthday & anniversary",
          "Valentine's / Mother's / Father's",
          "Christmas, Easter & Diwali",
          "Bridal, baby & housewarming",
        ],
      },
      {
        slug: "gift-concierge",
        name: "Gift Concierge",
        desc: "Not sure what to choose? We create it.",
        items: [
          "Tell us the recipient",
          "Choose your budget",
          "Share the occasion",
          "We curate & personalise",
          "Collect or schedule delivery",
        ],
      },
      {
        slug: "signature-scents",
        name: "Signature Scents",
        desc: "Gentle fragrances for you & your home.",
        items: ["Herbal Deodorant", "Home Perfume", "Lavish Cloth Perfumes"],
      },
    ],
  },
  {
    num: "02",
    title: "Celebrations",
    tagline: "Designed around your story.",
    image:
      "https://images.pexels.com/photos/5834736/pexels-photo-5834736.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Hands clinking champagne glasses in celebration",
    services: [
      {
        slug: "weddings-engagements",
        name: "Weddings & Engagements",
        desc: "From save-the-date to thank-you.",
        items: [
          "Invitations & save-the-dates",
          "Wedding / engagement websites",
          "Welcome signs & seating charts",
          "Menus, place cards & table nos.",
          "Favours & proposal boxes",
        ],
      },
      {
        slug: "event-stationery",
        name: "Event Stationery",
        desc: "Everything speaks the same language.",
        items: [
          "Printed & digital invitations",
          "RSVP & thank-you cards",
          "Menus & welcome cards",
          "Gift tags & greeting cards",
          "QR cards & event signage",
        ],
      },
    ],
  },
  {
    num: "03",
    title: "Custom Creations",
    tagline: "Create something that doesn't exist yet.",
    image: null,
    services: [
      {
        slug: "home-decor",
        name: "Home & Décor",
        desc: "Make your space feel like yours.",
        items: [
          "Family & house name signs",
          "Wall art & illustrations",
          "Photo frames & LED-style signs",
          "Cushions, blankets & coasters",
          "Nursery & housewarming pieces",
        ],
      },
      {
        slug: "custom-apparel",
        name: "Custom Apparel",
        desc: "Your idea, made wearable.",
        items: [
          "T-shirts & hoodies",
          "Polos, workwear & caps",
          "Tote bags & event shirts",
          "Couple / bridal party apparel",
          "Baby onesies & custom clothing",
        ],
      },
      {
        slug: "print-personalise",
        name: "Print & Personalise",
        desc: "One piece or a coordinated collection.",
        items: [
          "DTF & heat-transfer",
          "Vinyl & sublimation",
          "Stickers, labels & decals",
          "Mugs, tumblers & bottles",
          "Names, monograms & artwork",
        ],
      },
    ],
  },
  {
    num: "04",
    title: "Business & Branding",
    tagline: "Make your brand feel considered.",
    image:
      "https://images.unsplash.com/photo-1716540103530-cc33cdd20cde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwcGFja2FnaW5nfGVufDB8fHx8MTc4NzM4NDU3MHww&ixlib=rb-4.1.0&q=85",
    imageAlt: "Elegant black gift box with gold detailing",
    services: [
      {
        slug: "corporate-gifting",
        name: "Corporate Gifting",
        desc: "Thoughtful moments for clients & teams.",
        items: [
          "Client & settlement hampers",
          "Employee welcome packs",
          "Staff appreciation gifts",
          "Christmas & EOFY hampers",
          "Milestones & conference packs",
        ],
      },
      {
        slug: "branded-merchandise",
        name: "Branded Merchandise",
        desc: "Useful products carrying your identity.",
        items: [
          "Drinkware & stationery",
          "Totes & promotional products",
          "T-shirts, polos & hoodies",
          "Caps, uniforms & event merch",
          "Custom branded gift sets",
        ],
      },
      {
        slug: "business-branding",
        name: "Business Branding",
        desc: "Brand details customers can touch.",
        items: [
          "Cards, flyers & brochures",
          "Labels, stickers & tags",
          "Thank-you cards & inserts",
          "Banners, signage & decals",
          "QR signage & uniforms",
        ],
      },
    ],
  },
  {
    num: "05",
    title: "Packaging & Digital",
    tagline: "Complete the experience.",
    image:
      "https://images.pexels.com/photos/31496295/pexels-photo-31496295.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Beautifully wrapped gift box with layered ribbons",
    services: [
      {
        slug: "custom-packaging",
        name: "Custom Packaging",
        desc: "Make opening it part of the gift.",
        items: [
          "Gift & mailer boxes",
          "Tissue, ribbon & sleeves",
          "Logo stickers & product tags",
          "Inserts & thank-you cards",
          "Seasonal / corporate packaging",
        ],
      },
      {
        slug: "occasion-websites",
        name: "Occasion Websites",
        desc: "A beautiful home for the celebration.",
        items: [
          "Wedding & engagement sites",
          "Birthday & event pages",
          "Online RSVP & countdowns",
          "Maps, schedules & guest details",
          "QR galleries & invitations",
        ],
      },
      {
        slug: "small-business-digital",
        name: "Small Business Digital",
        desc: "Simple, polished and on-brand.",
        items: [
          "Small-business websites",
          "Landing & campaign pages",
          "Online gift catalogues",
          "Digital business cards",
          "Product & QR landing pages",
        ],
      },
    ],
  },
];
